import { TranslateServiceType } from '@/services/translateService'
import { TranslateServiceConsts } from '@/services/translateService/consts'
import { userService } from '@/services/userService'
import { DownOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useState } from 'react'
import { SearchPopover } from '../SearchPopover /SearchPopover'
import { UpgradeLinkBtn } from '../UpgradeLinkBtn/UpgradeLinkBtn'
import { VipBadge } from '../VipBadge/VipBadge'
import style from './TranslateSpeedSetting.module.less'

export const TranslateSpeedSettingPopover = observer(
  ({ childrenClassName, className }: { childrenClassName: string; className: string }) => {
    const [value, setValue] = useState<TranslateServiceType.TranslateSpeed>(
      userService.translateSpeed
    )
    const isUltra = userService.vipVersion === 'ultra'
    const isFree = userService.vipVersion === 'free'
    return (
      <div className={classNames(style.translateSpeedSettingPopover, className)}>
        <SearchPopover
          footerComponent={
            <>
              {(isFree || !isUltra) && (
                <div className={classNames(style.footer)}>
                  <UpgradeLinkBtn
                    version={isFree ? 'max' : 'ultra'}
                    text={isFree ? '解锁高级线路' : '解锁优质线路'}
                    source='translateSpeedSettingPopover'
                    feature='translateSpeed'
                  />
                </div>
              )}
            </>
          }
          placement='bottomRight'
          searchEnable={false}
          menuList={TranslateServiceConsts.TRANSLATE_SPEED_CONFIG_OPTIONS}
          getPopupContainer={(el) => el.parentElement!}
          value={value}
          onValueChange={(value) => {
            // 非 Ultra 会员不能选择 Ultra 线路
            if (value === 'ultra' && !isUltra) {
              userService.doPay({
                from: 'translateSpeedSettingPopover',
                feature: 'translateSpeed',
                version: 'ultra',
              })
              return
            }
            // 免费会员只能选择基础线路
            if (value !== 'base' && isFree) {
              userService.doPay({
                from: 'translateSpeedSettingPopover',
                feature: 'translateSpeed',
                version: 'max',
              })
              return
            }
            setValue(value)
          }}
          onRenderItem={(menuItem) => {
            return (
              <div
                style={{ display: 'flex', alignItems: 'space-between' }}
                className={classNames(style.main)}
              >
                {menuItem.label}
                {menuItem.value === 'max' && <VipBadge version='max' />}
                {menuItem.value === 'ultra' && <VipBadge version='ultra' />}
              </div>
            )
          }}
          onLoadChildren={(menuItem) => {
            return (
              <p className={classNames(style.valueItem, childrenClassName)}>
                <span className={classNames(style.name)}>{menuItem.label}</span>
                <DownOutlined className={classNames(style.arrow)} />
              </p>
            )
          }}
        ></SearchPopover>
      </div>
    )
  }
)
